import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ColorsComponent } from './colors/colors.component';
import { StyledComponentsComponent } from './styled-components/styled-components.component';
import { IconsComponent } from './icons/icons.component';
import { StyleGuideComponent } from './style-guide.component';
import { TypographyComponent } from './typography/typography.component';
import { UnstyledComponentsComponent } from './unstyled-components/unstyled-components.component';

const routes: Routes = [
  {
    path: '',
    component: StyleGuideComponent,
    children: [
      { path: 'colors', component: ColorsComponent, data: { title: 'Style Guide | Colors' } },
      { path: 'typography', component: TypographyComponent, data: { title: 'Style Guide | Typography' } },
      { path: 'icons', component: IconsComponent, data: { title: 'Style Guide | Icons' } },
      {
        path: 'styled-components',
        component: StyledComponentsComponent,
        data: { title: 'Style Guide | Styled Components' },
      },
      {
        path: 'unstyled-components',
        component: UnstyledComponentsComponent,
        data: { title: 'Style Guide | Unstyled Components' },
      },
      { path: '**', redirectTo: 'colors' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StyleGuideRoutingModule {}
